import { Box, Button, Typography } from '@mui/material';
import { cloneDeep, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import LoadingIconOnly from 'src/components/ui-component/loading/LoadingIconOnly';
import MuiSnackbar from 'src/components/ui-component/mui-snackbar/MuiSnackbar';
import { useAuthentication } from 'src/context/AuthContext';
import GetRecord from 'src/lib/api/GetRecord';
import PutRecord from 'src/lib/api/PutRecord';
import { APIS } from 'src/lib/constants/apis';
import { AUTH_TOKEN_DATA, NOT_FOUND_ERROR_MESSAGE } from 'src/lib/constants/constant';
import { removeDataKeys, removeNullDeep } from 'src/utils/helper';
import PersonalDataValidator from './PersonalDataValidator';

// import schemas
import Schema from 'src/lib/paths/person_FULL_Paths.json';
let P = Schema.attributes;

const formStruc = [
	{ fields: [P.Personenbezogene_Daten_Anrede, P.Personenbezogene_Daten_Titel] },
	{ fields: [P.Personenbezogene_Daten_Vorname, P.Personenbezogene_Daten_Nachname] },
	{ fields: [P.Kontaktdaten_E_Mail, P.Kontaktdaten_Fax] },
	{ fields: [P.Kontaktdaten_Telefon] },
];

const PersonalData: FC<{}> = () => {
	const { authenticatedData } = useAuthentication();
	const [loading, setLoading] = useState<boolean>(true);
	const [updateSuccess, setUpdateSuccess] = useState<boolean | null>(null);
	const [wsError, setWsError] = useState<boolean>(false);
	const [personData, setPersonData] = useState<Record<string, any>>({});
	const [formErrors, setFormErrors] = useState<Record<string, any>>({});

	const handleInputChange = (path: string, value: any) => {
		setUpdateSuccess(null);
		let personDataCopy = cloneDeep(personData);
		set(personDataCopy, path, value);
		setPersonData(personDataCopy);
	};
	const validatePersonData = () => {
		let errorObject = {};
		let errs = PersonalDataValidator.validate(personData);
		for (let error of errs) {
			set(errorObject, error.path, get(error, 'message'));
		}
		setFormErrors(errorObject);
		return Object.keys(errorObject).length === 0;
	};
	const handleUpdatePersonData = async () => {
		if (validatePersonData()) {
			let res = await PutRecord(APIS.Person, get(authenticatedData, AUTH_TOKEN_DATA.personId), { data: get(personData, 'attributes') });
			if (get(res, 'data.id')) setUpdateSuccess(true);
		}
	};

	useEffect(() => {
		const fetchPerson = async () => {
			setLoading(true);
			try {
				let res = await GetRecord(APIS.Person, get(authenticatedData, AUTH_TOKEN_DATA.personId));
				setPersonData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));
			} catch (err) {
				console.error('ERROR Fetching Person ', err);
				setWsError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchPerson();
	}, [authenticatedData]);

	if (loading) return <LoadingIconOnly />;
	return (
		<>
			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage={NOT_FOUND_ERROR_MESSAGE} error={wsError} />
			<MuiSnackbar showSnackbar={updateSuccess} closeSnackbar={() => setUpdateSuccess(null)} alertMessage='Daten wurde aktualisiert' />
			<Typography variant='h3' component='h2' sx={{ mb: 2 }}>
				Persönliche Daten
			</Typography>
			<Typography>
				Bitte beachten Sie, dass bei einer Änderung Ihrer E-Mail-Adresse gegebenenfalls auch die E-Mail-Adresse unter Organisationsprofil →
				Mailbenachrichtigungen angepasst werden muss.
			</Typography>
			<CreateForm
				formStruc={formStruc}
				formValues={personData}
				formErrors={formErrors}
				updateFormValuesFunc={handleInputChange}
				api={APIS.Person}
			/>

			<Box sx={{ textAlign: 'right', mt: '2rem' }}>
				<Button onClick={handleUpdatePersonData}>Aktualisieren</Button>
			</Box>
		</>
	);
};
export default PersonalData;
